// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__vu9X4","logo":"Footer_logo__NS366"};